<template>
  <div>
    <el-drawer :title="title" :visible.sync="drawer" size="80%">
      <OperationStopPower
        :isLog="true"
        @view="view"
        :devId="row.Id"
        v-if="drawer"
      ></OperationStopPower>
    </el-drawer>
    <EditForm ref="EditForm" />
  </div>
</template>
<script>
import OperationStopPower from './OperationStopPower.vue'
import EditForm from './EditForm.vue'
export default {
  data() {
    return {
      drawer: false,
      title: '',
      row: {},
    }
  },
  props: {},
  components: { OperationStopPower, EditForm },
  methods: {
    view(row) {
      this.$refs.EditForm.openForm('查看记录', row)
    },
    openView(title, row = {}) {
      this.title = title
      this.row = row
      console.log(row, 'rrrrrrrr')
      this.drawer = true
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin-bottom: 0px;
  padding: 20px;
}
</style>
